import React from "react";
import { Select } from "antd";
import { DropdownWrapper } from "./DropdownStyled";
import PropTypes from "prop-types";
const Dropdown = ({
  options,
  defaultValue,
  handleChange,
  value,
  allowborder,
  disabled = false,
  pagination = false,
}) => (
  <DropdownWrapper wrap allowborder={allowborder} pagination={pagination}>
    <Select
      popupMatchSelectWidth={false}
      defaultValue={defaultValue}
      value={value}
      onChange={handleChange}
      options={options}
      className="dropdown-container"
      disabled={disabled}
    />
  </DropdownWrapper>
);
export default Dropdown;
Dropdown.propTypes = {
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  allowborder: PropTypes.bool,
  disabled: PropTypes.bool,
  pagination: PropTypes.bool,
};